module.exports = __webpack_public_path__ + "media/audio8.978adf2e.mp3";